<!-- f r o m 7 5  2 7 1  8 9 2 0 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="处理状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- <a-input placeholder="请输入名称查询" v-model="queryParam.supplier"></a-input> -->
                  <a-select v-model="queryParam.status" placeholder="请选择类型">
                    <a-select-option value="1">已处理</a-select-option>
                    <a-select-option value="0">未处理</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称" v-model="queryParam.meterailaName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="产品码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品码" v-model="queryParam.code"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="扫码时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!-- <a-input placeholder="请输入手机号码查询" v-model="queryParam.telephone"></a-input> -->
                  <a-range-picker style="width:100%" v-model="queryParam.supplier" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateChange" @ok="onDateOk" />
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入联系电话查询" v-model="queryParam.phonenum"></a-input>
                </a-form-item>
              </a-col> -->
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <!-- <a-button @click="fwSubmit" type="primary">防伪参数配置</a-button> -->
          <!-- <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleImportXls()" type="primary" icon="import">导入</a-button> -->
          <!-- <a-button type="primary" icon="download" @click="handleExportXls('客户信息')">导出</a-button> -->
          <!-- <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1" v-if="btnEnableList.indexOf(1)>-1" @click="batchDel"><a-icon type="delete" />删除</a-menu-item>
              <a-menu-item key="2" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetStatus(true)"><a-icon type="check-square" />启用</a-menu-item>
              <a-menu-item key="3" v-if="btnEnableList.indexOf(1)>-1" @click="batchSetStatus(false)"><a-icon type="close-square" />禁用</a-menu-item>
            </a-menu>
            <a-button>
              批量操作 <a-icon type="down" />
            </a-button>
          </a-dropdown> -->
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'2%'}"  :scroll="{ x: true }"  :loading="loading" @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a-popconfirm v-if="record.status!=1" title="确定处理选择的数据吗？" ok-text="是" cancel-text="否" @confirm="confirm(record)" @cancel="cancel">
                <a href="#">处理</a>
              </a-popconfirm>
              <!-- <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a @click="handleUser(record)">账号信息</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1&&record.isOpenTransshipment" type="vertical" />
              <a v-if="record.isOpenTransshipment" @click="handlechanneling(record)">防窜货配置</a> -->
            </span>
            <!-- 状态渲染模板 -->
            <!-- <template slot="isfch" slot-scope="text, record">
              <a-switch v-model="record.isOpenTransshipment" @change="change(record)" checked-children="是" un-checked-children="否" />
              <a-tag v-if="isOpenTransshipment==1" color="green">是</a-tag>
              <a-tag v-if="isOpenTransshipment==0" color="orange">否</a-tag>
            </template> -->
            <!-- <template slot="level" slot-scope="levelRegulation">
              <a-tag v-if="levelRegulation==0" color="green">全国</a-tag>
              <a-tag v-if="levelRegulation==1" color="orange">省</a-tag>
              <a-tag v-if="levelRegulation==2" color="orange">市</a-tag>
              <a-tag v-if="levelRegulation==3" color="orange">区</a-tag>
            </template> -->
            <template slot="type" slot-scope="status">
              <a-tag v-if="status==1" color="green">已处理</a-tag>
              <a-tag v-if="status==0" color="orange">未处理</a-tag>
            </template>
            <template slot="date" slot-scope="createTime">
              <span>{{timestampToTime(createTime)}}</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <fwModel ref="fwModel" @ok="modalFormOk"></fwModel>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- BY cao_yu_li -->
<script>
import fwModel from './modules/fwModel'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getUser, editSupplier, securityWarning } from '@/api/api.js'
export default {
  name: 'CustomerList',
  mixins: [JeecgListMixin],
  components: {
    fwModel,
  },
  data() {
    return {
      checked: false,
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      queryParam: {
        code: '',
        meterailaName: '',
        status: undefined,
        resultCode: 0,
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 表头
      columns: [
        {
          title: '操作',
          dataIndex: 'action',
          width: 20,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
        { title: '处理状态', dataIndex: 'status', width: 25, align: 'center', scopedSlots: { customRender: 'type' } },
        { title: '产品名称', dataIndex: 'meterailaName', width: 80, align: 'left' },

        { title: '产品码', dataIndex: 'code', width: 150, align: 'left' },
        {
          title: '扫码时间',
          dataIndex: 'createTime',
          width: 60,
          align: 'left',
          scopedSlots: { customRender: 'date' },
        },
        { title: '扫码地址', dataIndex: 'locationName', width: 100, align: 'left' },
        // { title: '经销商主营区域', dataIndex: 'locationName', width: 150, align: 'left' },
        // {
        //   title: '监管级别',
        //   dataIndex: 'levelRegulation',
        //   width: 150,
        //   align: 'left',
        //   scopedSlots: { customRender: 'level' },
        // },

        // { title: '扫码地址', dataIndex: 'contacts', width: 70, align: 'left' },
        // { title: '扫码时间', dataIndex: 'telephone', width: 100, align: 'left' },
        // { title: '联系电话', dataIndex: 'phoneNum', width: 100, align: 'left' },
        // { title: '电子邮箱', dataIndex: 'email', width: 150, align: 'left' },
        // { title: '期初应收', dataIndex: 'beginNeedGet', width: 80, align: 'left' },
        // { title: '期末应收', dataIndex: 'allNeedGet', width: 80, align: 'left' },
        // { title: '税率(%)', dataIndex: 'taxRate', width: 80, align: 'left' },
        // { title: '排序', dataIndex: 'sort', width: 60, align: 'left' },
        // {
        //   title: '状态',
        //   dataIndex: 'enabled',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
      url: {
        list: '/securityRecord/list',
        delete: '/supplier/delete',
        deleteBatch: '/supplier/deleteBatch',
        importExcelUrl: '/supplier/importCustomer',
        exportXlsUrl: '/supplier/exportExcel',
        batchSetStatusUrl: '/supplier/batchSetStatus',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    onDateOk(value) {
      console.log(value)
    },
    onDateChange: function (value, dateString) {
      this.queryParam.beginTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    fwSubmit() {
      this.$refs.fwModel.add()
    },
    async confirm(record) {
      console.log(record)
      const res = await securityWarning({ uuid: record.uuid })
      console.log(res, 'res')
      if (res.code == 200) {
        this.$message.success('处理成功')
        this.loadData()
      }
    },
    change(record) {
      console.log(record, 'record')
      let params = {
        id: record.id,
        isOpenTransshipment: record.isOpenTransshipment ? '1' : '0',
      }
      console.log(params, 'params')
      editSupplier(params)
    },
    // 防窜货
    handlechanneling(record) {
      this.$refs.AntiModel.add(record)
    },
    async handleUser(record) {
      let obj = {
        search: { userName: record.supplier },
        currentPage: 1,
        pageSize: 10,
      }
      const res = await getUser(obj)
      console.log(res, 'res')
      let list = res.data.rows
      if (list.length > 0) {
        this.$refs.userinfoModel.add(list)
      } else {
        console.log(record, '11')
        this.$refs.useraddModel.add(record)
      }
    },
    searchReset() {
      this.queryParam = {
        // type: '客户',
      }
      this.loadData(1)
    },
    handleImportXls() {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/customer_template.xls'
      let templateName = '客户Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '客户导入'
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>